import React, { useEffect } from "react";
import { useAuth } from "hooks/authentication/useAuth";
import { Navigate, useNavigate } from "react-router-dom";
import { useState } from "react";

const NotFound = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    (() => {
      if (!user) {
        navigate("/login");
      }
    })();
  }, []);

  return null;
};

export default NotFound;
